"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2242],{

/***/ 3231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "setupAgentSession": function() { return /* binding */ setupAgentSession; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/drain/drain.js
var drain = __webpack_require__(1019);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/contextual-ee.js
var contextual_ee = __webpack_require__(5891);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/ids/unique-id.js
var unique_id = __webpack_require__(765);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timer/timer.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
class Timer {
  constructor(opts, ms) {
    if (!opts.onEnd) throw new Error('onEnd handler is required');
    if (!ms) throw new Error('ms duration is required');
    this.onEnd = opts.onEnd;
    this.initialMs = ms;
    this.startTimestamp = Date.now();
    this.timer = this.create(this.onEnd, ms);
  }
  create(cb, ms) {
    if (this.timer) this.clear();
    return setTimeout(() => cb ? cb() : this.onEnd(), ms || this.initialMs);
  }
  clear() {
    clearTimeout(this.timer);
    this.timer = null;
  }
  end() {
    this.clear();
    this.onEnd();
  }
  isValid() {
    return this.initialMs - (Date.now() - this.startTimestamp) > 0;
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/session/constants.js
var constants = __webpack_require__(9181);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/page-visibility.js
var page_visibility = __webpack_require__(7973);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/invoke.js
var invoke = __webpack_require__(2016);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timer/interaction-timer.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */




class InteractionTimer extends Timer {
  constructor(opts, ms) {
    super(opts, ms);
    this.onPause = typeof opts.onPause === 'function' ? opts.onPause : () => {/* noop */};
    this.onRefresh = typeof opts.onRefresh === 'function' ? opts.onRefresh : () => {/* noop */};
    this.onResume = typeof opts.onResume === 'function' ? opts.onResume : () => {/* noop */};

    /** used to double-check LS state at resume time */
    this.readStorage = opts.readStorage;

    // used by pause/resume
    this.remainingMs = undefined;
    if (!opts.refreshEvents) opts.refreshEvents = ['click', 'keydown', 'scroll'];

    // the abort controller is used to "reset" the event listeners and prevent them from duplicating when new sessions are created
    try {
      this.abortController = new AbortController();
    } catch (e) {
      // this try-catch can be removed when IE11 is completely unsupported & gone
    }
    if (runtime/* isBrowserScope */.il && opts.ee) {
      if (opts.ee) {
        this.ee = opts.ee;
        const debouncedRefresh = (0,invoke/* debounce */.D)(this.refresh.bind(this), 500, {
          leading: true
        });
        this.refreshHandler = evts => {
          if (opts.refreshEvents.includes(evts?.[0]?.type)) {
            debouncedRefresh();
          }
        };
        opts.ee.on('fn-end', this.refreshHandler);
      }

      // watch for the vis state changing.  If the page is hidden, the local inactivity timer should be paused
      // if the page is brought BACK to visibility and the timer hasnt "naturally" expired, refresh the timer...
      // this is to support the concept that other tabs could be experiencing activity.  The thought would be that
      // "backgrounded" tabs would pause, while "closed" tabs that "reopen" will just instantiate a new SessionEntity class if restored
      // which will do a "hard" check of the timestamps.

      // NOTE -- this does not account for 2 browser windows open side by side, blurring/focusing between them
      // IF DEEMED necessary, more event handling would be needed to account for this.
      (0,page_visibility/* subscribeToVisibilityChange */.N)(state => {
        if (state === 'hidden') this.pause();
        // vis change --> visible is treated like a new interaction with the page
        else this.resume();
      }, false, false, this.abortController?.signal);
    }
  }
  abort() {
    this.clear();
    this.abortController?.abort();
    if (this.refreshHandler) {
      this.ee.removeEventListener('fn-end', this.refreshHandler);
      this.refreshHandler = this.ee = null;
    }
  }
  pause() {
    this.onPause();
    clearTimeout(this.timer);
    this.remainingMs = this.initialMs - (Date.now() - this.startTimestamp);
  }
  resume() {
    try {
      const lsData = this.readStorage();
      const obj = typeof lsData === 'string' ? JSON.parse(lsData) : lsData;
      if (isExpired(obj.expiresAt) || isExpired(obj.inactiveAt)) this.end();else {
        this.refresh();
        this.onResume(); // emit resume event after state updated
      }
    } catch (err) {
      this.end();
    }
    function isExpired(timestamp) {
      return Date.now() > timestamp;
    }
  }
  refresh(cb, ms) {
    this.clear();
    this.timer = this.create(cb, ms);
    this.startTimestamp = Date.now();
    this.remainingMs = undefined;
    this.onRefresh();
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/wrap/wrap-events.js
var wrap_events = __webpack_require__(1520);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/config/configurable.js
var configurable = __webpack_require__(56);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/constants.js + 1 modules
var metrics_constants = __webpack_require__(3705);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-listener/event-listener-opts.js
var event_listener_opts = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/logging/constants.js
var logging_constants = __webpack_require__(5146);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/session/session-entity.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
















// this is what can be stored in local storage (not enforced but probably should be)
// these values should sync between local storage and the parent class props
const model = {
  value: '',
  inactiveAt: 0,
  expiresAt: 0,
  updatedAt: Date.now(),
  sessionReplayMode: constants/* MODE.OFF */.IK.OFF,
  sessionReplaySentFirstChunk: false,
  sessionTraceMode: constants/* MODE.OFF */.IK.OFF,
  traceHarvestStarted: false,
  loggingMode: logging_constants/* LOGGING_MODE.OFF */.IG.OFF,
  serverTimeDiff: null,
  // set by TimeKeeper; "undefined" value will not be stringified and stored but "null" will
  custom: {}
};
class SessionEntity {
  /**
   * Create a self-managing Session Entity. This entity is scoped to the agent identifier which triggered it, allowing for multiple simultaneous session objects to exist.
   * There is one "namespace" an agent can store data in LS -- NRBA_{key}. If there are two agents on one page, and they both use the same key, they could overwrite each other since they would both use the same namespace in LS by default.
   * The value can be overridden in the constructor, but will default to a unique 16 character hex string
   * expiresMs and inactiveMs are used to "expire" the session, but can be overridden in the constructor. Pass 0 to disable expiration timers.
   */
  constructor(opts) {
    const {
      agentIdentifier,
      key,
      storage
    } = opts;
    if (!agentIdentifier || !key || !storage) {
      throw new Error("Missing required field(s):".concat(!agentIdentifier ? ' agentID' : '').concat(!key ? ' key' : '').concat(!storage ? ' storage' : ''));
    }
    this.agentIdentifier = agentIdentifier;
    this.storage = storage;
    this.state = {};

    // key is intended to act as the k=v pair
    this.key = key;
    this.ee = contextual_ee.ee.get(agentIdentifier);
    (0,wrap_events/* wrapEvents */.e)(this.ee);
    this.setup(opts);

    /**
     * Do not emit session storage events for IE11, because IE11 is unable to determine
     * if the event was spawned on the current page or an adjacent page, and the behavior tied
     * to storage events is critical to apply only to cross-tab behavior
     * */
    if (runtime/* isBrowserScope */.il) {
      (0,event_listener_opts/* windowAddEventListener */.bP)('storage', event => {
        if (event.key === this.lookupKey) {
          const obj = typeof event.newValue === 'string' ? JSON.parse(event.newValue) : event.newValue;
          this.sync(obj);
          this.ee.emit(constants/* SESSION_EVENTS.UPDATE */.wO.UPDATE, [constants/* SESSION_EVENT_TYPES.CROSS_TAB */.uT.CROSS_TAB, this.state]);
        }
      });
    }
  }
  setup({
    value = (0,unique_id/* generateRandomHexString */.ky)(16),
    expiresMs = constants/* DEFAULT_EXPIRES_MS */.oD,
    inactiveMs = constants/* DEFAULT_INACTIVE_MS */.Hb
  }) {
    /** Ensure that certain properties are preserved across a reset if already set */
    const persistentAttributes = {
      serverTimeDiff: this.state.serverTimeDiff || model.serverTimeDiff
    };
    this.state = {};
    this.sync({
      ...model,
      ...persistentAttributes
    });

    // value is intended to act as the primary value of the k=v pair
    this.state.value = value;
    this.expiresMs = expiresMs;
    this.inactiveMs = inactiveMs;

    // the first time the session entity class is instantiated, we check the storage API for an existing
    // object. If it exists, the values inside the object are used to inform the timers that run locally.
    // if the initial read is empty, it allows us to set a "fresh" "new" session immediately.
    // the local timers are used after the session is running to "expire" the session, allowing for pausing timers etc.
    // the timestamps stored in the storage API can be checked at initial run, and when the page is restored, otherwise we lean
    // on the local timers to expire the session
    const initialRead = this.read();

    // the set-up of the timer used to expire the session "naturally" at a certain time
    // this gets ignored if the value is falsy, allowing for session entities that do not expire
    if (expiresMs) {
      this.state.expiresAt = initialRead?.expiresAt || this.getFutureTimestamp(expiresMs);
      this.expiresTimer = new Timer({
        // When the inactive timer ends, collect a SM and reset the session
        onEnd: () => {
          this.collectSM('expired');
          this.collectSM('duration');
          this.reset();
        }
      }, this.state.expiresAt - Date.now());
    } else {
      this.state.expiresAt = Infinity;
    }

    // the set-up of the timer used to expire the session due to "inactivity" at a certain time
    // this gets ignored if the value is falsy, allowing for session entities that do not expire
    // this gets "refreshed" when "activity" is observed
    if (inactiveMs) {
      this.state.inactiveAt = initialRead?.inactiveAt || this.getFutureTimestamp(inactiveMs);
      this.inactiveTimer = new InteractionTimer({
        // When the inactive timer ends, collect a SM and reset the session
        onEnd: () => {
          this.collectSM('inactive');
          this.collectSM('duration');
          this.reset();
        },
        // When the inactive timer refreshes, it will update the storage values with an update timestamp
        onRefresh: this.refresh.bind(this),
        onResume: () => {
          this.ee.emit(constants/* SESSION_EVENTS.RESUME */.wO.RESUME);
        },
        // When the inactive timer pauses, update the storage values with an update timestamp
        onPause: () => {
          if (this.initialized) this.ee.emit(constants/* SESSION_EVENTS.PAUSE */.wO.PAUSE);
          this.write((0,configurable/* getModeledObject */.D)(this.state, model));
        },
        ee: this.ee,
        refreshEvents: ['click', 'keydown', 'scroll'],
        readStorage: () => this.storage.get(this.lookupKey)
      }, this.state.inactiveAt - Date.now());
    } else {
      this.state.inactiveAt = Infinity;
    }

    // The fact that the session is "new" or pre-existing is used in some places in the agent.  Session Replay and Trace
    // can use this info to inform whether to trust a new sampling decision vs continue a previous tracking effort.
    /* [NR-230914] 02/2024 - the logical OR assignment is used so that isNew remains 'true' if it was already set as such. This fixes the expires and inactive timestamps timing out in localStorage
      while no page for a given domain is in-use and the session resetting upon user returning to the page as part of a fresh session. */
    this.isNew ||= !Object.keys(initialRead).length;
    // if its a "new" session, we write to storage API with the default values.  These values may change over the lifespan of the agent run.
    // we can use a modeled object here to help us know and manage what values are being used. -- see "model" above
    if (this.isNew) this.write((0,configurable/* getModeledObject */.D)(this.state, model), true);else this.sync(initialRead);
    this.initialized = true;
    this.ee.emit(constants/* SESSION_EVENTS.STARTED */.wO.STARTED, [this.isNew]);
  }

  // This is the actual key appended to the storage API
  get lookupKey() {
    return "".concat(constants/* PREFIX */.Bq, "_").concat(this.key);
  }
  sync(data) {
    Object.assign(this.state, data);
  }

  /**
   * Fetch the stored values from the storage API tied to this entity
   * @returns {Object}
   */
  read() {
    try {
      const val = this.storage.get(this.lookupKey);
      if (!val) return {};
      // TODO - decompression would need to happen here if we decide to do it
      const obj = typeof val === 'string' ? JSON.parse(val) : val;
      if (this.isInvalid(obj)) return {};
      // if the session expires, collect a SM count before resetting
      if (this.isExpired(obj.expiresAt)) {
        this.collectSM('expired');
        this.collectSM('duration', obj, true);
        return this.reset();
      }
      // if "inactive" timer is expired at "read" time -- esp. initial read -- reset
      // collect a SM count before resetting
      if (this.isExpired(obj.inactiveAt)) {
        this.collectSM('inactive');
        this.collectSM('duration', obj, true);
        return this.reset();
      }
      return obj;
    } catch (e) {
      (0,console/* warn */.Z)(10, e);
      // storage is inaccessible
      return {};
    }
  }

  /**
   * Store data to the storage API tied to this entity
   * To preseve existing attributes, the output of ...session.read()
   * should be appended to the data argument
   * @param {Object} data
   * @returns {Object}
   */
  write(data) {
    try {
      if (!data || typeof data !== 'object') return;
      // everytime we update, we can update a timestamp for sanity
      data.updatedAt = Date.now();
      this.sync(data); // update the parent class "state" properties with the local storage values
      //
      // TODO - compression would need happen here if we decide to do it
      this.storage.set(this.lookupKey, (0,stringify/* stringify */.P)(this.state));
      this.ee.emit(constants/* SESSION_EVENTS.UPDATE */.wO.UPDATE, [constants/* SESSION_EVENT_TYPES.SAME_TAB */.uT.SAME_TAB, this.state]);
      return data;
    } catch (e) {
      // storage is inaccessible
      (0,console/* warn */.Z)(11, e);
      return null;
    }
  }
  reset() {
    // this method should set off a chain of actions across the features by emitting 'new-session'
    // * send off pending payloads
    // * stop recording (stn and sr)...
    // * delete the session and start over
    try {
      if (this.initialized) this.ee.emit(constants/* SESSION_EVENTS.RESET */.wO.RESET);
      this.storage.remove(this.lookupKey);
      this.inactiveTimer?.abort?.();
      this.expiresTimer?.clear?.();
      delete this.isNew;
      this.setup({
        agentIdentifier: this.agentIdentifier,
        key: this.key,
        storage: this.storage,
        expiresMs: this.expiresMs,
        inactiveMs: this.inactiveMs
      });
      return this.read();
    } catch (e) {
      return {};
    }
  }

  /**
   * Refresh the inactivity timer data
   */
  refresh() {
    // read here & invalidate
    const existingData = this.read();
    this.write({
      ...existingData,
      inactiveAt: this.getFutureTimestamp(this.inactiveMs)
    });
  }

  /**
   * @param {number} timestamp
   * @returns {boolean}
   */
  isExpired(timestamp) {
    return Date.now() > timestamp;
  }

  /**
   * @param {Object} data
   * @returns {boolean}
   */
  isInvalid(data) {
    const requiredKeys = Object.keys(model);
    return !requiredKeys.every(x => Object.keys(data).includes(x));
  }
  collectSM(type, data, useUpdatedAt) {
    let value, tag;
    if (type === 'duration') {
      value = this.getDuration(data, useUpdatedAt);
      tag = 'Session/Duration/Ms';
    }
    if (type === 'expired') tag = 'Session/Expired/Seen';
    if (type === 'inactive') tag = 'Session/Inactive/Seen';
    if (tag) (0,handle/* handle */.p)(metrics_constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, [tag, value], undefined, features/* FEATURE_NAMES.metrics */.DT.metrics, this.ee);
  }
  getDuration(data = this.state, useUpdatedAt) {
    const startingTimestamp = data.expiresAt - this.expiresMs;
    const endingTimestamp = !useUpdatedAt ? data.updatedAt : Date.now();
    return endingTimestamp - startingTimestamp;
  }

  /**
   * @param {number} futureMs - The number of ms to use to generate a future timestamp
   * @returns {number}
   */
  getFutureTimestamp(futureMs) {
    return Date.now() + futureMs;
  }
  syncCustomAttribute(key, value) {
    if (!runtime/* isBrowserScope */.il) return;
    if (value === null) {
      const curr = this.read();
      if (curr.custom) {
        delete curr.custom[key];
        this.write({
          ...curr
        });
      }
    } else {
      const curr = this.read();
      this.custom = {
        ...(curr?.custom || {}),
        [key]: value
      };
      this.write({
        ...curr,
        custom: this.custom
      });
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/storage/local-storage.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
class LocalStorage {
  get(key) {
    try {
      // localStorage strangely type-casts non-existing data to "null"...
      // Cast it back to undefined if it doesnt exist
      return localStorage.getItem(key) || undefined;
    } catch (err) {
      // Error is ignored
      return '';
    }
  }
  set(key, value) {
    try {
      if (value === undefined || value === null) return this.remove(key);
      return localStorage.setItem(key, value);
    } catch (err) {
      // Error is ignored
    }
  }
  remove(key) {
    try {
      localStorage.removeItem(key);
    } catch (err) {
      // Error is ignored
    }
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/agent-session.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */






function setupAgentSession(agentRef) {
  if (agentRef.runtime.session) return agentRef.runtime.session; // already setup

  const sessionInit = agentRef.init.session;
  agentRef.runtime.session = new SessionEntity({
    agentIdentifier: agentRef.agentIdentifier,
    key: constants/* DEFAULT_KEY */.K4,
    storage: new LocalStorage(),
    expiresMs: sessionInit?.expiresMs,
    inactiveMs: sessionInit?.inactiveMs
  });

  // Retrieve & re-add all of the persisted setCustomAttribute|setUserId k-v from previous page load(s), if any was stored.
  const customSessionData = agentRef.runtime.session.state.custom;
  if (customSessionData) {
    agentRef.info.jsAttributes = {
      ...agentRef.info.jsAttributes,
      ...customSessionData
    };
  }
  const sharedEE = contextual_ee.ee.get(agentRef.agentIdentifier);

  // any calls to newrelic.setCustomAttribute(<persisted>) will need to be added to:
  // local info.jsAttributes {}
  // the session's storage API
  (0,register_handler/* registerHandler */.X)('api-setCustomAttribute', (time, key, value) => {
    agentRef.runtime.session.syncCustomAttribute(key, value);
  }, 'session', sharedEE);

  // any calls to newrelic.setUserId(...) will need to be added to:
  // local info.jsAttributes {}
  // the session's storage API
  (0,register_handler/* registerHandler */.X)('api-setUserId', (time, key, value) => {
    agentRef.runtime.session.syncCustomAttribute(key, value);
  }, 'session', sharedEE);
  (0,drain/* drain */.LP)(agentRef.agentIdentifier, 'session');
  return agentRef.runtime.session;
}

/***/ })

}]);